import RangeToStepsConverterBase from './RangeToStepsConverterBase.js';

class LinearRangeToStepsConverter extends RangeToStepsConverterBase {
    constructor(numOfSteps){
        super();

        if (!Number.isInteger(numOfSteps)){
            throw new TypeError('numOfSteps must be an integer');
        }

        if (numOfSteps < 0){
            throw new Error('numOfSteps must be greater than 0');
        }

        this.numOfSteps = numOfSteps;
    }

    getSteps(min, max){
        const range = max - min;
        const increment = range / this.numOfSteps ;
        const steps = [];

        for (let i = 0; i < this.numOfSteps; ) {
            steps.push([
                min + increment * i,
                min + increment * ++i
            ]);
        }

        return steps;
    }
}

export default LinearRangeToStepsConverter;